/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface HealthSurveyStatusDto
 */
export interface HealthSurveyStatusDto {
    /**
     * 
     * @type {string}
     * @memberof HealthSurveyStatusDto
     */
    'seizuresCharacteristics'?: HealthSurveyStatusDtoSeizuresCharacteristicsEnum;
    /**
     * 
     * @type {string}
     * @memberof HealthSurveyStatusDto
     */
    'seizuresHistory'?: HealthSurveyStatusDtoSeizuresHistoryEnum;
    /**
     * 
     * @type {string}
     * @memberof HealthSurveyStatusDto
     */
    'treatment'?: HealthSurveyStatusDtoTreatmentEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum HealthSurveyStatusDtoSeizuresCharacteristicsEnum {
    Completed = 'COMPLETED',
    NeedsAttention = 'NEEDS_ATTENTION'
}
/**
    * @export
    * @enum {string}
    */
export enum HealthSurveyStatusDtoSeizuresHistoryEnum {
    Completed = 'COMPLETED',
    NeedsAttention = 'NEEDS_ATTENTION'
}
/**
    * @export
    * @enum {string}
    */
export enum HealthSurveyStatusDtoTreatmentEnum {
    Completed = 'COMPLETED',
    NeedsAttention = 'NEEDS_ATTENTION'
}


